import { OrgLevel, OrgType, OrgUnitAssortmentDTO } from '@retail/auth/types';

export class OrgUnitType {
  static readonly RETAIL_BRAND = new OrgUnitType('RETAIL', 'BRAND', 'FULL');
  static readonly RETAIL_DATAOWNER = new OrgUnitType('RETAIL', 'DATAOWNER', 'FULL');
  static readonly RETAIL_LOCATION = new OrgUnitType('RETAIL', 'LOCATION', 'FULL');
  static readonly RETAIL_LOCATION_LIGHT = new OrgUnitType('RETAIL', 'LOCATION', 'LIGHT');
  static readonly RETAIL_LOCATION_LIGHT_PLUS = new OrgUnitType('RETAIL', 'LOCATION', 'LIGHT');
  static readonly RETAIL_LOCATION_UNDER_MASTER = new OrgUnitType(
    'RETAIL',
    'LOCATION',
    'FULL',
    OrgUnitType.RETAIL_LOCATION
  );
  static readonly WHOLESALE_BRAND = new OrgUnitType('WHOLESALE', 'BRAND', 'FULL');
  static readonly WHOLESALE_LOCATION = new OrgUnitType('WHOLESALE', 'LOCATION', 'FULL');
  static readonly WHOLESALE_PRICE_LIST = new OrgUnitType('WHOLESALE', 'PRICE_LIST', 'FULL');

  private constructor(
    public readonly channel: 'RETAIL' | 'WHOLESALE',
    public readonly level: OrgLevel,
    public readonly version: 'FULL' | 'LIGHT',
    private readonly variantOf?: OrgUnitType
  ) {}

  get baseType(): OrgUnitType {
    return this.variantOf ?? this;
  }

  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  getName = () => Object.entries(OrgUnitType).find(([, value]) => value === this)![0];

  static values(): OrgUnitType[] {
    return [
      OrgUnitType.RETAIL_BRAND,
      OrgUnitType.RETAIL_DATAOWNER,
      OrgUnitType.RETAIL_LOCATION,
      OrgUnitType.WHOLESALE_LOCATION,
      OrgUnitType.RETAIL_LOCATION_LIGHT,
      OrgUnitType.RETAIL_LOCATION_LIGHT_PLUS,
      OrgUnitType.RETAIL_LOCATION_UNDER_MASTER,
      OrgUnitType.WHOLESALE_PRICE_LIST,
      OrgUnitType.WHOLESALE_BRAND,
    ];
  }

  static getOrgUnitType = ({
    assortmentLevel,
    version,
    channel,
    hasCompetitorPrices,
    hasMasterAssortment,
  }: Partial<OrgUnitAssortmentDTO>): OrgUnitType => {
    if (channel === 'WHOLESALE') {
      if (assortmentLevel === 'BRAND') {
        return OrgUnitType.WHOLESALE_BRAND;
      } else if (assortmentLevel === 'LOCATION') {
        return OrgUnitType.WHOLESALE_LOCATION;
      } else {
        return OrgUnitType.WHOLESALE_PRICE_LIST;
      }
    } else {
      if (assortmentLevel === 'BRAND') return OrgUnitType.RETAIL_BRAND;
      if (assortmentLevel === 'DATAOWNER') return OrgUnitType.RETAIL_DATAOWNER;
      if (hasMasterAssortment) return OrgUnitType.RETAIL_LOCATION_UNDER_MASTER;
      switch (version) {
        case 'FULL':
          return OrgUnitType.RETAIL_LOCATION;
        case 'LIGHT':
        default:
          if (hasCompetitorPrices) return OrgUnitType.RETAIL_LOCATION_LIGHT_PLUS;
          return OrgUnitType.RETAIL_LOCATION_LIGHT;
      }
    }
  };
  static fromOrgUnitType = (orgUnitType: OrgUnitType) => orgUnitType.getName() as OrgType;
}
